
import imagePath from '@/mixins/imagePath';
export default {
    name: 'EcomMenuBadges',
    mixins: [imagePath],
    props: {
        badge: {
            type: Object,
            default: () => ({})
        }
    }
};
